import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

export default ({styles, handleSubmit, handleChange, args, errors}) => {
  const fechaHoy = new Date()
  const hora = fechaHoy.getHours()
  let saludo = "!! Buenas noches !!"
  if(hora>=6&&hora<12){
    saludo = "!! Buenos días !!"
  }
  if(hora>=12&&hora<18){
    saludo = "!! Buenas tardes !!"
  }
  return (
    <div style={styles.box}>
      <div>
        <h1 style={{color: 'white', fontWeight: 'bold'}}>{saludo}</h1>
        <Divider inverted />
        <p style={{color: 'white'}}>Bienvenido a</p>
        <p style={{color: 'white'}}>SLCM - Software de Lubricación de clase mundial</p>
        {/* <img src="images/foroptic.png" alt="Logo"/> */}

        <Divider inverted />
        <br></br>

        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
            <Form.Field>
                <label style={styles.label}>Correo electrónico</label>
                <Form.Input name="email" onChange={handleChange} placeholder='Correo electrónico' icon={!errors.length?null: _find(errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
            </Form.Field>
            <Form.Field>
                <label style={styles.label}>Clave de acceso</label>
                <Form.Input autoComplete="off" name="claveDeAcceso" onChange={handleChange}  type='password' placeholder='Clave de acceso' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
            </Form.Field>
            {/* <hr></hr> */}

            <Divider inverted />

            {/* <Divider/> */}

            <Button style={styles.confirmar} type='submit' fluid>
                Ingresar
            </Button>
            <br></br>

            {/* <Button type='submit' primary fluid>Ingresar</Button> */}

            {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

        </Form>
    </div>
  </div>)
}
